export default __webpack_public_path__ + "static/media/logo.bcea129b.png";